module.exports = __webpack_public_path__ + "img/group.b144bf80.png";